import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: '首页', icon: 'ri-home-line' },
    { path: '/category/shaonian-rexue', label: '分类', icon: 'ri-menu-line' },
    { path: '/', label: '排行', icon: 'ri-bar-chart-line' },
    { path: '/', label: '更新', icon: 'ri-time-line' },
    { path: '/about', label: '关于', icon: 'ri-information-line' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group">
            <div className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
              isScrolled || !isHome ? 'bg-primary-500' : 'bg-white/20 backdrop-blur-sm'
            }`}>
              <i className={`ri-book-read-line text-lg ${isScrolled || !isHome ? 'text-white' : 'text-white'}`}></i>
            </div>
            <span className={`font-heading text-lg font-bold tracking-wide whitespace-nowrap transition-colors ${
              isScrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              土豪漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-primary-500 ${
                  location.pathname === link.path
                    ? isScrolled || !isHome ? 'text-primary-500' : 'text-white'
                    : isScrolled || !isHome ? 'text-foreground-700' : 'text-white/80'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setIsSearchOpen(!isSearchOpen)}
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
                isScrolled || !isHome ? 'hover:bg-background-200 text-foreground-700' : 'hover:bg-white/10 text-white'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`w-9 h-9 md:hidden flex items-center justify-center rounded-full transition-colors cursor-pointer ${
                isScrolled || !isHome ? 'hover:bg-background-200 text-foreground-700' : 'hover:bg-white/10 text-white'
              }`}
              aria-label="菜单"
            >
              <i className={`text-lg ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isSearchOpen && (
          <div className="pb-4 px-1">
            <div className="flex items-center gap-2 bg-background-100 rounded-full px-4 py-2.5 border border-background-200/70">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索漫画名称、作者..."
                className="flex-1 bg-transparent text-sm text-foreground-900 placeholder-foreground-400 outline-none border-none"
              />
              <button className="bg-primary-500 text-white text-sm px-5 py-1.5 rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
                搜索
              </button>
            </div>
          </div>
        )}
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-colors ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${link.icon} text-base w-5 h-5 flex items-center justify-center`}></i>
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}